import { render, staticRenderFns } from "./dragBox.vue?vue&type=template&id=678c6c30"
import script from "./dragBox.vue?vue&type=script&lang=js"
export * from "./dragBox.vue?vue&type=script&lang=js"
import style0 from "./dragBox.vue?vue&type=style&index=0&id=678c6c30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports